import React from 'react';
import { Result, Button, Card, Space, Typography, Divider } from 'antd';
import { CheckCircleOutlined, HomeOutlined, MessageOutlined, HeartOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/Dashboard/DashboardLayout';

const { Title, Paragraph, Text } = Typography;

const FeedbackThankYou = () => {
    const navigate = useNavigate();

    return (
        <DashboardLayout>
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: 'calc(100vh - 200px)',
            }}>
                <Card
                    style={{
                        maxWidth: 700,
                        width: '100%',
                        borderRadius: 16,
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                        border: 'none'
                    }}
                >
                    <div>
                        {/* Success Icon */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: 32
                        }}>
                            <div style={{
                                width: 120,
                                height: 120,
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 8px 16px rgba(82, 196, 26, 0.3)',
                                animation: 'pulse 2s ease-in-out infinite'
                            }}>
                                <CheckCircleOutlined style={{ 
                                    color: '#fff', 
                                    fontSize: 64,
                                    fontWeight: 'bold'
                                }} />
                            </div>
                        </div>

                        {/* Title */}
                        <Title 
                            level={2} 
                            style={{ 
                                textAlign: 'center',
                                marginBottom: 16,
                                fontSize: 32,
                                fontWeight: 700,
                                background: 'linear-gradient(135deg, #1890ff 0%, #52c41a 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text'
                            }}
                        >
                            Feedback Submitted Successfully!
                        </Title>

                        {/* Subtitle */}
                        <Paragraph 
                            style={{ 
                                textAlign: 'center',
                                fontSize: 17,
                                color: '#595959',
                                lineHeight: 1.8,
                                marginBottom: 40,
                                maxWidth: 520,
                                margin: '0 auto 40px'
                            }}
                        >
                            Thank you for taking the time to share your feedback. We'll review it and get back to you if needed.
                        </Paragraph>

                        {/* Info Cards */}
                        <Space 
                            direction="vertical" 
                            size="large" 
                            style={{ 
                                width: '100%', 
                                marginBottom: 40 
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 12,
                                padding: '16px 24px',
                                background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                                borderRadius: 12,
                                border: '1px solid #bae6fd'
                            }}>
                                <HeartOutlined style={{ 
                                    fontSize: 20, 
                                    color: '#1890ff' 
                                }} />
                                <Text strong style={{ 
                                    fontSize: 15, 
                                    color: '#0369a1' 
                                }}>
                                    Your feedback helps us improve our platform
                                </Text>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 12,
                                padding: '16px 24px',
                                background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
                                borderRadius: 12,
                                border: '1px solid #bbf7d0'
                            }}>
                                <ClockCircleOutlined style={{ 
                                    fontSize: 20, 
                                    color: '#52c41a' 
                                }} />
                                <Text strong style={{ 
                                    fontSize: 15, 
                                    color: '#166534' 
                                }}>
                                    We typically respond within 24-48 hours
                                </Text>
                            </div>
                        </Space>


                        {/* Action Buttons */}
                        <Space 
                            size="large" 
                            style={{ 
                                width: '100%', 
                                justifyContent: 'center',
                                flexWrap: 'wrap'
                            }}
                        >
                          
                            <Button
                                icon={<MessageOutlined />}
                                size="large"
                                onClick={() => navigate('/feedback')}
                                style={{
                                    borderRadius: 10,
                                    fontWeight: 600,
                                    height: 48,
                                    padding: '0 36px',
                                    fontSize: 16,
                                    border: '2px solid #1890ff',
                                    color: '#1890ff',
                                    background: '#fff',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = '#f0f9ff';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = '#fff';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                Submit Another Feedback
                            </Button>
                        </Space>
                    </div>
                </Card>
            </div>

            <style>{`
                @keyframes pulse {
                    0%, 100% {
                        transform: scale(1);
                    }
                    50% {
                        transform: scale(1.05);
                    }
                }
            `}</style>
        </DashboardLayout>
    );
};

export default FeedbackThankYou;

